import type { IconSvgObject } from './types';

const Undo03Icon: IconSvgObject = [
  ["path", { d: "M3 8H15C18.3137 8 21 10.6863 21 14C21 17.3137 18.3137 20 15 20H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 4L5.8462 4.87652C3.94873 6.31801 3 7.03875 3 8C3 8.96125 3.94873 9.68199 5.8462 11.1235L7 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Undo03Icon;
